import { Version } from 'models';
import { BalanceType } from 'utils/enums';

import { customFormat } from 'utils';

export const buildURL = (
  coopId: string,
  fiscalYearId: string,
  startDate: Date,
  endDate: Date,
  version: Version,
  balanceType: BalanceType
) => {
  const baseURL = new URL(
    `${window.location.origin}/reports/cooperative/balance/${coopId}`
  );

  baseURL.searchParams.append('fiscalYearId', fiscalYearId);
  baseURL.searchParams.append(
    'startDate',
    customFormat(startDate, 'server') as string
  );
  baseURL.searchParams.append(
    'endDate',
    customFormat(endDate, 'server') as string
  );
  baseURL.searchParams.append('shortLongVersion', version.value.toString());
  baseURL.searchParams.append('del', balanceType.toString());

  return baseURL.href;
};
